export const chatKeys = {
  all: ['chat'],
  rooms: ['chat', 'rooms'],
  roomList: (params: any) => ['chat', 'rooms', 'list', params],
  roomDetail: (id: any) => ['chat', 'rooms', 'detail', id],
  messages: ['chat', 'messages'],
  messageList: (params: any) => ['chat', 'messages', 'list', params],
  messageDetail: (id: any) => ['chat', 'messages', 'detail', id],
};
